import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'

import sideBarControler from './sidebar'
import MoneyPoolBoxAdd from './moneyPoolBox'
import imageReducer from './image'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['MoneyPoolBoxAdd'],
}

const rootReducer = combineReducers({
    sideBarControler: sideBarControler,
    MoneyPoolBoxAdd: MoneyPoolBoxAdd,
    imageReducer: imageReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
